import { useStore } from 'stook'

interface ISelfArrivalCity {
  cityCode: number | string;
  cityName: string;
  provinceCode?: number | string;
  provinceName?: string;
  address?: string;
}

export default function useSelfArrivalCity() {
  const [selfArrivalCity, setSelfArrivalCity] = useStore<ISelfArrivalCity>(
    'SelfArrivalCity',
    {
      cityCode: 0,
      cityName: '',
      provinceCode: '',
      provinceName: '',
      address: ''
    }
  )

  return { selfArrivalCity, setSelfArrivalCity }
}
